var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "comment"
}, /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.42969 14.8737V20L7.76565 17.29C8.38169 17.4275 9.02222 17.5 9.67969 17.5H12.1797C17.0122 17.5 20.9297 13.5825 20.9297 8.75C20.9297 3.91751 17.0122 0 12.1797 0H9.67969C4.8472 0 0.929688 3.91751 0.929688 8.75C0.929688 11.1341 1.8832 13.2956 3.42969 14.8737ZM7.53772 15.9584L4.67969 17.7447V14.3634L4.32249 13.9989C2.95697 12.6054 2.17969 10.7406 2.17969 8.75C2.17969 4.60786 5.53755 1.25 9.67969 1.25H12.1797C16.3218 1.25 19.6797 4.60786 19.6797 8.75C19.6797 12.8921 16.3218 16.25 12.1797 16.25H9.67969C9.12154 16.25 8.57217 16.1892 8.03789 16.07L7.53772 15.9584Z",
  fill: "#415385"
})));

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.b5536634.svg";
export { ForwardRef as ReactComponent };